import {useCallback, useEffect, useRef, useState} from 'react';
import styles from './AnimatedCounterCard.module.scss';

export interface AnimatedCounterCardProps {
  text: string;
  value: number;
  valueText?: string;
  type: string;
}

function AnimatedCounterCard({
  text,
  value,
  type,
  valueText,
}: AnimatedCounterCardProps) {
  function countUp(value: number) {
    if (typeof value !== 'number') {
      return 0;
    }
    const [state, setState] = useState(0);
    const ref = useRef(0);

    const updateCounterState = useCallback(() => {
      if (ref.current < value) {
        const remaining = value - ref.current;
        const increment = Math.max(1, Math.floor(remaining / 30));
        ref.current += increment;
        setState(ref.current);
      } else {
        setState(value);
      }
      requestAnimationFrame(updateCounterState);
    }, [value]);

    useEffect(() => {
      updateCounterState();
    }, [updateCounterState]);

    return state;
  }

  return (
    <div className={`${styles.card} ${styles[type]}`}>
      <span className={styles.value}>
        {countUp(value)}
        {valueText && ` ${valueText}`}
      </span>
      <span className={styles.text}>{text}</span>
    </div>
  );
}

export default AnimatedCounterCard;
